import React from 'react';

interface Props {
  message?: string;
}

const ConnectingOverlay: React.FC<Props> = ({ message }) => {
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(245,245,245,0.98)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999
    }}>
      <div style={{
        background: '#ffffff', border: '1px solid #e0e0e0', borderRadius: 8,
        padding: '20px 24px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
        display: 'flex', alignItems: 'center', gap: 12
      }}>
        <div style={{ width: 18, height: 18, border: '2px solid #e0e0e0', borderTop: '2px solid #1976d2', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
        <div style={{ fontSize: 14, color: '#212121' }}>{message || 'Łączenie z serwerem…'}</div>
      </div>
      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default ConnectingOverlay;


